import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';

const generateComment = async (
  language: string,
  tonality: string,
  duzen: boolean,
  review: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.post('/comment-ai/generate', {
      language,
      tonality,
      duzen,
      review,
    });
    loading(false);
    const { message } = data;
    return message;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const CommentAiService = {
  generateComment,
};

export default CommentAiService;
